import { render, staticRenderFns } from "./PuntosGestionMapPoli.vue?vue&type=template&id=7226ec07"
import script from "./PuntosGestionMapPoli.vue?vue&type=script&lang=js"
export * from "./PuntosGestionMapPoli.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports